/** @jsxImportSource @emotion/react */
import { Select } from '../../../design-system/atoms/Select/Select';
import { Input } from '../../../design-system/atoms/Input/Input';
import { Cluster } from '../../../design-system/layout/Cluster';

export interface JobFilters {
  module: string;
  status: string;
  trigger: string;
  date: string;
}

export interface JobFilterBarProps {
  moduleOptions: string[];
  statusOptions: string[];
  triggerOptions: string[];
  values: JobFilters;
  onChange: (patch: Partial<JobFilters>) => void;
}

/** 빈 값(전체)을 첫 옵션으로 붙인 목록 구성. */
function withAll(label: string, options: string[]) {
  return [{ label, value: '' }, ...options.map((o) => ({ label: o, value: o }))];
}

/** 수집 이력 필터 줄. 모듈·상태·트리거·날짜 조건 선택에 활용. */
export function JobFilterBar({ moduleOptions, statusOptions, triggerOptions, values, onChange }: JobFilterBarProps) {
  return (
    <Cluster gap="sm">
      <Select
        options={withAll('모듈: 전체', moduleOptions)}
        value={values.module}
        onChange={(v) => onChange({ module: v })}
      />
      <Select
        options={withAll('상태: 전체', statusOptions)}
        value={values.status}
        onChange={(v) => onChange({ status: v })}
      />
      <Select
        options={withAll('트리거: 전체', triggerOptions)}
        value={values.trigger}
        onChange={(v) => onChange({ trigger: v })}
      />
      <Input type="date" value={values.date} onChange={(v) => onChange({ date: v })} />
    </Cluster>
  );
}
